/**
 * Created by Pankaj singh on 2019-10-18.
 */

import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";

export interface IRomanEmpireSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    initialWin:ISymbolStateConfig;
}

export class RomanEmpireReelSymbol extends StateReelSymbol {
    public static _isIdleAnimation:boolean = false;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }


    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        const symName:string = this.symName;
        if(RomanEmpireGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symName) !== -1) {
            if(newState.state.keyword === RomanEmpireGameConfig.instance.SYMBOL_STATES.initialWin.keyword) {
                timeline.add(new SpineTween((stateAnimation as any), 0, symName.toLowerCase() + "_win", 0), delay);
                if(RomanEmpireReelSymbol._isIdleAnimation) {
                    TweenLite.delayedCall(0, () => {
                        stateAnimation.alpha = 1;
                    })
                } else {
                    timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha : 1}), delay);
                }

                return;
            }

            if(newState.state.keyword === RomanEmpireGameConfig.instance.SYMBOL_STATES.normal.keyword) {
                timeline.add(new SpineTween((stateAnimation as any), 0, symName.toLowerCase() + "_normal", 0), delay);
                timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha : 1}), delay);
                return;
            }
        }


        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
    }


}